const CN_REGEX = new RegExp(/CN=[^/]*/)

/**
 * @example getMatchedCNString('/C=US/ST=Pennsylvania/L=Pittsburgh/O=Visionet Systems/OU=Partner Link/CN=WernerAS2PROD3/emailAddress=PartnerLinkSupport@partnerlinkedi.com') // '/CN=WernerAS2PROD3'
 */
export const getMatchedCNString = (str: string): string => {
  const firstMatch = str.match(CN_REGEX) || ''

  return firstMatch[0]
}
